// import { t } from "i18next";

import CountryFlags from "../../assets/icons/country-flags/CountryFlags";

const LanguageOptions = [
  {
    value: "English",
    label: (
      <>
        <CountryFlags.USA className="mr-2 align-middle" />
        {/* {t("languages.english")} */} English
      </>
    ),
  },
  {
    value: "Hebrew",
    label: (
      <>
        <CountryFlags.IL className="mr-2 align-middle" />
        {/* {t("languages.hebrew")} */}Hebrew
      </>
    ),
  },
  {
    value: "Spanish",
    label: (
      <>
        <CountryFlags.ES className="mr-2 align-middle" />
        {/* {t("languages.spanish")} */} Spanish
      </>
    ),
  },
  // {
  //   value: "Russian",
  //   label: (
  //     <>
  //       <CountryFlags.RU className="mr-2 align-middle" />
  //       Russian
  //     </>
  //   ),
  // },
  // {
  //   value: "French",
  //   label: (
  //     <>
  //       <CountryFlags.FR className="mr-2 align-middle" />
  //       French
  //     </>
  //   ),
  // },
  // {
  //   value: "Dutch",
  //   label: (
  //     <>
  //       <CountryFlags.NL className="mr-2 align-middle" />
  //       Dutch
  //     </>
  //   ),
  // },
];

export default LanguageOptions;
